export type LocaleByCountry = {
    language: string;
    locale: string;
};

/**
 * Locales grouped by country (lowercase key, e.g. 'be'/'fr'), REACTIVE.
 * Returns a ComputedRef so consumers repopulate when the available locales finish loading
 * (the translations are fetched async; a one-shot snapshot taken before that resolves is empty,
 * which is why the locale pill rendered nothing on pages that do not pre-load via the auth layout).
 * Templates auto-unwrap the ref; in script use `.value`.
 */
export default function useAvailableLocalesByCountry() {
    const translation = useTranslation();

    return computed<Record<string, LocaleByCountry[]>>(() => {
        const grouped: Record<string, LocaleByCountry[]> = {};

        for (const item of translation.availableLocales.value) {
            const [country, language] = item.locale.split('-');
            if (!country) continue;

            (grouped[country] ??= []).push({ language: language ?? item.language, locale: item.locale });
        }

        return grouped;
    });
}
